import { AccountArrowRightOutlineIcon } from './AccountArrowRightOutlineIcon';

/**
 * author: Coffeemate
 * id 7CB2DA6F-D0F6-4A7A-A761-E53B564744E8
 * name account-arrow-right-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-right-outline.svg
 * tags
 * - Account / User 
 */
export const UserArrowRightOutlineIcon = AccountArrowRightOutlineIcon;
export default UserArrowRightOutlineIcon